"use strict";

exports.__esModule = true;
exports.DataTableWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("../common/ChartCard");
var _reactIntl = require("react-intl");
var _DataTableElement = require("./DataTableElement");
var _DataTableFields = require("./DataTableFields");
var _DataTableThumbnail = require("./DataTableThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DataTableWidget = exports.DataTableWidget = {
  name: "DataTable",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DataTableWidget.label",
    defaultMessage: "Tickets/Alerts Table"
  }),
  icon: "th-list",
  group: _widgetGroups.DIGITAL_LOG_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "DataTable",
      props: Object.assign({
        dataSource: "Alerts",
        width: 512,
        height: 512,
        ticketsWithComments: true
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "onClickAction"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_DataTableElement.DataTableElement),
    Fields: _DataTableFields.DataTableFields,
    Thumbnail: _DataTableThumbnail.DataTableThumbnail
  }
};